
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    checkOperationResult,
    setOperationError,
    setOperationStart
} from '../common/client/sagas/common';

import { knDataExec } from './serverApi/project';

export const GET_OPSUB_ACTION_TYPE = createActionTypes('opsub/GET');

export default function getActions(dispatch) {
    return {
        getOpsub: (token, projectId, katuzeKod, isknDate) => dispatch({
            type: GET_OPSUB_ACTION_TYPE.DEFAULT, token, projectId, katuzeKod, isknDate,
            operation: GET_OPSUB_ACTION_TYPE.DEFAULT
        })
    };
}

function* workGetOpsub(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: GET_OPSUB_ACTION_TYPE.LOADING});
        const data = yield call(knDataExec, options.serverApi, action);
        yield put({type: GET_OPSUB_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data.result, {title: title});
    } catch (error) {
        yield call(setOperationError, error, GET_OPSUB_ACTION_TYPE);
    }
}

export function* watchGetOpsub(options) {
    yield takeEvery(
        GET_OPSUB_ACTION_TYPE.DEFAULT, workGetOpsub, options,
        'Načtení seznamu vlastníků'
    );
}
